import { getConfig } from '@/features/environment/config';

import { createApiInstance } from '@/shared/authentication';

export const api = createApiInstance({
  baseURL: `${getConfig()?.ORGANIZATION_URL}`,
  timeout: 20000
});

const organizationAPI = {
  addUserRole: (organizationName: string, userName: string, role: string) =>
    api.post(`${organizationName}/users/${userName}/roles/${role}`),

  removeUserRole: (organizationName: string, userName: string, role: string) =>
    api.delete(`${organizationName}/users/${userName}/roles/${role}`),

  getOrganizationNameLogoUpload: async (organizationName: string) =>
    await api.get(`${organizationName}/logo/upload`)
};

export default organizationAPI;
